import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

function BlogView({ darkMode }) {
  const [post, setPost] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await fetch(`/api/blogs/${slug}`);
        const data = await res.json();
        setPost(data);
      } catch (err) {
        console.error('Failed to load blog post', err);
      }
    };
    fetchPost();
  }, [slug]);

  if (!post) return <div className="p-6 text-center">Loading post...</div>;

  return (
    <div className={`max-w-4xl mx-auto p-6 pb-24 ${darkMode ? 'text-white bg-gray-800' : 'text-black bg-white'}`}> {/* pb-24 lagt til for å unngå overlap med BottomBar */}
      <h1 className="text-3xl font-bold mb-2">{post.title}</h1>
      <p className="text-sm italic text-gray-400 mb-4">
        by {post.author?.name || 'Unknown'} on {new Date(post.createdAt).toLocaleDateString()}
      </p>
      <div className="prose prose-lg max-w-none">
        <ReactMarkdown>{post.content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default BlogView;